import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "-my-3 divide-y" }
const _hoisted_2 = { class: "font-medium text-gray-900" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["href", "aria-label"]
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 4 }



import Button from 'primevue/button';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

import type { EducationalMaterial } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductMaterials',
  props: {
    materials: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.materials?.length)
    ? (_openBlock(), _createBlock(_unref(Accordion), {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AccordionPanel), { value: "0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordionHeader), null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Materiały edukacyjne")
                ])),
                _: 1
              }),
              _createVNode(_unref(AccordionContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (material) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: material.id,
                        class: "space-y-2 py-3"
                      }, [
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(material.title), 1),
                        (material.type === 'textarea')
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              innerHTML: material.content
                            }, null, 8, _hoisted_3))
                          : (material.type === 'image')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: material.content,
                                alt: ""
                              }, null, 8, _hoisted_4))
                            : (material.type === 'url')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createElementVNode("a", {
                                    href: material.content,
                                    "aria-label": material.content,
                                    target: "_blank",
                                    rel: "noreferrer"
                                  }, [
                                    _createVNode(_unref(Button), {
                                      size: "small",
                                      variant: "link",
                                      outlined: "",
                                      severity: "secondary"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-external-link" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(material.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 8, _hoisted_6)
                                ]))
                              : (material.type === 'file')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("a", {
                                      href: material.content,
                                      download: "",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }, [
                                      _createVNode(_unref(Button), {
                                        size: "small",
                                        outlined: "",
                                        severity: "secondary"
                                      }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                          _createElementVNode("i", { class: "pi pi-download" }, null, -1),
                                          _createTextVNode(" Pobierz ")
                                        ])),
                                        _: 1
                                      })
                                    ], 8, _hoisted_8)
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_9, "nieobsługiwany typ materiału"))
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})